import R from "ramda";
import { useSelector } from "react-redux";

import { useCategoryActions } from "store/CategorySlice";

const useCategory = () => {
  const { loadCategory, resetCategory } = useCategoryActions();

  const { category } = useSelector((state) => state.CategorySlice);

  const CategoryCards = category && category.templateGroups;

  const categoryStarringYouCards =
    CategoryCards && CategoryCards.filter((ecard) => ecard.templateGroupType === "starring_you");

  const featuredStarringYouCards = CategoryCards && R.take(4, categoryStarringYouCards);

  const categoryStarringYouClipCards =
    CategoryCards && CategoryCards.filter((ecard) => ecard.templateGroupType === "starring_you_clip");

  const categoryStraightUpCards =
    CategoryCards && CategoryCards.filter((ecard) => ecard.templateGroupType === "straight_up");

  return {
    loadCategory,
    resetCategory,
    category,
    categoryStarringYouCards,
    categoryStraightUpCards,
    categoryStarringYouClipCards,
    featuredStarringYouCards,
  };
};

export default useCategory;
